import React, { useEffect, useMemo, useState } from 'react';

import { Typography, useTheme } from '@mui/material';

import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { HelpdeskCard } from './HelpdeskCard';
import api from '../../../../../services/api';

function HelpdeskOpenCard() {
  const theme = useTheme();
  const [total, setTotal] = useState(-1);
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const { data } = await api.get<{ total: number }>('v2/helpdesk/dashboard/my/open');

      setTotal(data.total || 0);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const renderCard = useMemo(() => {
    return (
      <HelpdeskCard
        loading={loading}
        title="Solicitações abertas"
        content={
          <Typography variant="h3" fontWeight="400">
            {Intl.NumberFormat('pt-BR').format(total)}
          </Typography>
        }
        subcontent={
          <Typography variant="caption">{total > 1 ? 'solicitações abertas' : 'solicitação aberta'}</Typography>
        }
        icon={<HelpOutlineOutlinedIcon color="primary" sx={{ fontSize: 64 }} />}
        color={theme.palette.primary.main}
      />
    );
  }, [theme.palette.primary.main, total, loading]);

  return renderCard;
}

export { HelpdeskOpenCard };
